import Index from '../../views/setting/assignLoanOfficer/Index'
import List from '../../views/setting/assignLoanOfficer/List'
import Permissions from '@/permissions'

export const assignLoanOfficerRouters = {
  path: 'assign-loan-officer',
  component: Index,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.assignLoanOfficer.manage],
    groups: 'assignLoanOfficer'
  },
  children: [
    {
      path: '',
      name: 'assign-loan-officer-list',
      component: List,
      meta: {
        permissions: [
          Permissions.backend.setting.assignLoanOfficer.list
        ],
        groups: 'assignLoanOfficer',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Assign Loan Officer',
            name_km: 'ចាត់តាំងមន្រ្តីឥណទាន'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
